<template>
  <div class="supplier-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <span class="breadcrumb-item" @click="goToMaterial">材价信息</span>
      <img class="separator" src="@/assets/image/you.png" alt="">
      <span>供应商列表</span>
    </div>

    <!-- 供应商列表 -->
    <div class="supplier-list">
      <div
        v-for="(supplier, index) in supplierList"
        :key="index"
        class="supplier-card"
        @click="goToCardList(supplier)"
      >
        <!-- 供应商头像 -->
        <div class="supplier-avatar">
          <img
            :src="supplier.avatar"
            :alt="supplier.companyName"
            class="avatar-img"
          >
        </div>

        <!-- 供应商信息 -->
        <div class="supplier-info">
          <!-- 公司名称和认证状态 -->
          <div class="company-header">
            <h3 class="company-name">{{ supplier.companyName }}</h3>
            <div class="certification">
              <img
                src="@/assets/image/yrz.png"
                alt="已认证"
                class="cert-icon"
              >
              <span class="cert-text">已认证</span>
            </div>
          </div>

          <!-- 详细信息 -->
          <div class="detail-info">
            <div class="info-item">
              <span class="info-label">入驻:</span>
              <span class="info-value">{{ supplier.entryDate }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">地区:</span>
              <span class="info-value">{{ supplier.location }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">业务:</span>
              <span class="info-value">{{ supplier.mainBusiness }}</span>
            </div>
            <div class="contact-info">
              <img
                src="@/assets/image/phone.png"
                alt="电话"
                class="phone-icon"
              >
              <span class="phone-number">{{ supplier.phoneNumber }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplierList',
  data() {
    return {
      supplierList: [
        {
          avatar: require('@/assets/image/1.jpg'), // 使用现有的头像图片
          companyName: '路达科技有限公司',
          entryDate: '2025-03-02',
          location: '河南省郑州市二七区',
          mainBusiness: '五金商品的供应',
          phoneNumber: '100 0000 0000'
        },
        {
          avatar: require('@/assets/image/1.jpg'),
          companyName: '路达科技有限公司',
          entryDate: '2025-03-02',
          location: '河南省郑州市二七区',
          mainBusiness: '五金商品的供应',
          phoneNumber: '100 0000 0000'
        },
        {
          avatar: require('@/assets/image/1.jpg'),
          companyName: '路达科技有限公司',
          entryDate: '2025-03-02',
          location: '河南省郑州市二七区',
          mainBusiness: '五金商品的供应',
          phoneNumber: '100 0000 0000'
        },
        {
          avatar: require('@/assets/image/1.jpg'),
          companyName: '路达科技有限公司',
          entryDate: '2025-03-02',
          location: '河南省郑州市二七区',
          mainBusiness: '五金商品的供应',
          phoneNumber: '100 0000 0000'
        },
        {
          avatar: require('@/assets/image/1.jpg'),
          companyName: '路达科技有限公司',
          entryDate: '2025-03-02',
          location: '河南省郑州市二七区',
          mainBusiness: '五金商品的供应',
          phoneNumber: '100 0000 0000'
        },
        {
          avatar: require('@/assets/image/1.jpg'),
          companyName: '路达科技有限公司',
          entryDate: '2025-03-02',
          location: '河南省郑州市二七区',
          mainBusiness: '五金商品的供应',
          phoneNumber: '100 0000 0000'
        }
      ]
    }
  },

  methods: {
    // 返回材价信息页面
    goToMaterial() {
      this.$router.push('/material')
    },
    // 跳转到名片展示页面
    goToCardList(supplier) {
      // 将供应商信息存储到路由参数中
      this.$router.push({
        path: '/material/cardList',
        query: {
          companyName: supplier.companyName,
          entryDate: supplier.entryDate,
          location: supplier.location,
          mainBusiness: supplier.mainBusiness,
          phoneNumber: supplier.phoneNumber
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.supplier-container {
  width: var(--page-container-ratio, 70%);
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
}

/* 面包屑导航 */
.breadcrumb {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  color: #111111;
  font-size: 20px;
  background: #fff;
  height: 80px;
  padding: 0 30px;

  .breadcrumb-item {
    transition: color 0.3s ease;

    &:hover {
		cursor: pointer;
      color: #0c5bc4;
    }
  }

  .separator {
    margin: 0 8px;
    width: 8px;
  }
}

/* 供应商列表 */
.supplier-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  background: #fff;
  padding: 30px;
}

/* 供应商卡片 */
.supplier-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  aspect-ratio: 1;
  min-height: 280px;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-4px);
    border-color: #0f6fe2;
  }
}

/* 供应商头像 */
.supplier-avatar {
  margin-bottom: 16px;
  flex-shrink: 0;

  .avatar-img {
    width: 80px;
    height: 80px;
    border-radius: 12px;
    object-fit: cover;
    border: 2px solid #f0f0f0;
  }
}

/* 供应商信息 */
.supplier-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 12px;
}

/* 公司头部信息 */
.company-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  width: 100%;

  .company-name {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    text-align: center;
    line-height: 1.4;
  }

  .certification {
    display: flex;
    align-items: center;
    gap: 6px;

    .cert-icon {
      width: 16px;
      height: 16px;
    }

    .cert-text {
      font-size: 12px;
      color: #f39800;
      font-weight: 500;
    }
  }
}

/* 详细信息 */
.detail-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  flex: 1;
  justify-content: space-between;

  .info-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;

    .info-label {
      color: #999;
      min-width: 40px;
    }

    .info-value {
      color: #666;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .contact-info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px solid #f0f0f0;

    .phone-icon {
      width: 16px;
      height: 16px;
    }

    .phone-number {
      font-size: 14px;
      color: #0f6fe2;
      font-weight: 500;
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .supplier-container {
    width: 95%;
  }

  .supplier-list {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .supplier-container {
    width: 100%;
    padding: 15px;
  }

  .supplier-list {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
    padding: 20px;
  }

  .supplier-card {
    padding: 20px;
    min-height: 240px;
  }

  .avatar-img {
    width: 70px;
    height: 70px;
  }

  .company-name {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .supplier-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 15px;
  }

  .supplier-card {
    padding: 16px;
    min-height: 200px;
  }

  .avatar-img {
    width: 60px;
    height: 60px;
  }

  .company-name {
    font-size: 15px;
  }

  .detail-info .info-item {
    font-size: 12px;
  }

  .phone-number {
    font-size: 12px;
  }
}
</style>
